import { ShopperAiFlagKey } from "@redotech/feature-flags-keys-shopper-ai/keys";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";

function hidePadding(url: string): boolean {
  return (
    !!matchPath("/stores/:storeId/commerce-agent/playbook", url) ||
    !!matchPath("/stores/:storeId/commerce-agent/calendar", url) ||
    !!matchPath("/stores/:storeId/commerce-agent/conversations", url) ||
    !!matchPath("/stores/:storeId/commerce-agent/knowledge", url) ||
    !!matchPath("/stores/:storeId/commerce-agent/sandbox", url) ||
    !!matchPath("/stores/:storeId/commerce-agent/settings", url)
  );
}

function shopperAgentEnabledPermission({
  team,
}: {
  team: {
    featureFlags?: {
      [ShopperAiFlagKey.SHOPPER_AGENT]?: boolean;
      [ShopperAiFlagKey.SHOPPER_AGENT_GENERAL]?: boolean;
    };
  };
}): boolean {
  return (
    team.featureFlags?.[ShopperAiFlagKey.SHOPPER_AGENT] === true ||
    team.featureFlags?.[ShopperAiFlagKey.SHOPPER_AGENT_GENERAL] === true
  );
}

export const shopperAgentRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "Commerce Agent",
      permission: shopperAgentEnabledPermission,
    },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      {
        async lazy() {
          const { ConciergeAskRedoRouteContext } =
            await import("../../../concierge/concierge-ask-redo-route-context");
          return { Component: ConciergeAskRedoRouteContext };
        },
        children: [
          {
            handle: { breadcrumb: "Dashboard" },
            index: true,
            async lazy() {
              const { ConciergeIndexPage } =
                await import("../../../concierge/concierge-index-page");
              return { Component: ConciergeIndexPage };
            },
          },
          {
            path: "conversations",
            handle: { breadcrumb: "Conversations" },
            async lazy() {
              const { ShopperAgentConversationsPage } =
                await import("../../../shopper-agent/conversations/shopper-agent-conversations-page");
              return { Component: ShopperAgentConversationsPage };
            },
          },
          {
            path: "analytics",
            handle: { breadcrumb: "Analytics" },
            async lazy() {
              const { TextConciergeAnalyticsPage } =
                await import("@redotech/redo-merchant-marketing-app/text-concierge/analytics/text-concierge-analytics-page");
              return { Component: TextConciergeAnalyticsPage };
            },
          },
          {
            path: "calendar",
            handle: { breadcrumb: "Calendar" },
            async lazy() {
              const { ConciergeCalendarPage } =
                await import("../../../concierge/calendar/concierge-calendar-page");
              return { Component: ConciergeCalendarPage };
            },
          },
          {
            path: "sandbox",
            handle: { breadcrumb: "Sandbox" },
            async lazy() {
              const { ConciergeSandboxPage } =
                await import("../../../concierge/sandbox/concierge-sandbox-page");
              return { Component: ConciergeSandboxPage };
            },
          },
          {
            path: "knowledge",
            handle: { breadcrumb: "Knowledge" },
            async lazy() {
              const { ConciergeKnowledgePage } =
                await import("../../../setting/ai-agent/knowledge/page");
              return { Component: ConciergeKnowledgePage };
            },
          },
          {
            path: "settings",
            handle: { breadcrumb: "Settings" },
            async lazy() {
              const { ConciergeSettingsRoute } =
                await import("../../../concierge/concierge-settings-route");
              return { Component: ConciergeSettingsRoute };
            },
          },
          {
            path: "playbook",
            handle: { breadcrumb: "Playbook" },
            async lazy() {
              const { ConciergePlaybookRoute } =
                await import("../../../concierge/concierge-playbook-route");
              return { Component: ConciergePlaybookRoute };
            },
          },
        ],
      },
    ],
  },
];
